module.exports = __webpack_public_path__ + "img/homepage_3.dfde6651.jpg";